import React from 'react';
import { Column } from '@ant-design/charts';
import { Card } from 'antd';
const Attendence = () => {
  const data = [
    {
      courses: 'CAP323',
      percentage: 50,
    },
    {
      courses: 'CAP363',
      percentage: 35,
    },
    {
      courses: 'CAP366',
      percentage: 25,
    },
    {
      courses: 'CAP345',
      percentage: 15,
    },
    {
      courses: 'CAP396',
      percentage: 85,
    },
  ];
  const config = {
    title: {
      visible: true,
      text: 'Attendence',
    },
    description: {
      visible: true,
      text: 'subject wise',
    },
    forceFit: true,
    data,
    padding: 'auto',
    xField: 'courses',
    yField: 'percentage',
    conversionTag: { visible: true },
  };
  return (
      <>
      <Card>
        <Column {...config} />

      </Card>
       
      </>
  )

  
};

export default Attendence;